import { useEffect } from 'react';
import PropTypes from 'prop-types';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// utils
import { GLOBAL_ONLY_ROLES } from 'src/utils/roles';
//
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export default function ManagerDashboardGuard({ children }) {
  const router = useRouter();
  const { user } = useAuthContext();

  // Wait for user to be loaded
  const isLoading = !user;

  // Managers no longer have a Command Center. Stated as "who does": superadmins and
  // legislative members, both platform-wide roles that are always known from the global role.
  // Everyone else in web is an org manager — including an account whose global role still says
  // volunteer — so this holds without waiting on the org context to resolve.
  const globalRole = user?.users_user_roles?.[0]?.user_roles_roles?.code;
  const hasCommandCenter = GLOBAL_ONLY_ROLES.includes(globalRole);

  useEffect(() => {
    if (isLoading) return; // Don't run logic until data is loaded

    if (!hasCommandCenter) {
      router.replace(paths.dashboard.campaigns);
    }
  }, [hasCommandCenter, router, isLoading]);

  // Don't render the report dashboard for managers (will redirect)
  if (!hasCommandCenter || isLoading) {
    return null;
  }

  return <>{children}</>;
}

ManagerDashboardGuard.propTypes = {
  children: PropTypes.node,
};
